/*
  Vytelle Login Experience
  Used by Vytelle and Sense users on the existing domains.
*/

import React, { useEffect } from "react";

// Redux
import { useDispatch, useSelector } from "react-redux";

// Antd
import { Col, Row } from "antd";

// Components
import Loading from "@Vytelle/authentication/src/components/Loading";
import LoginForm from "./LoginForm";

// Actions
import { logout } from "@Vytelle/authentication/src/store/actions/AuthAction";

// Localization
import LOCALIZATION from "@Vytelle/authentication/src/services/LocalizationService";

// Images
import vytelleLogo from "@Vytelle/authentication/src/assets/images/vytelle-logo.svg";

// Style
import "../style.scss";

const VYTELLE_MARKETING_URL =
  "https://vytelle.com/?utm_source=vytellesenseui&utm_medium=website&utm_campaign=alwaysprogressing&utm_term=ui";

function VytelleLogin() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.Auth?.loading);

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  return (
    <>
      {loading && <Loading />}

      <Row className="authentication-wrapper vytelle-login">
        <Col span={24} className="vytelle-login-shell">
          <img className="vytelle-login-logo" src={vytelleLogo} alt="Vytelle logo" />

          <div className="vytelle-login-content">
            <div className="vytelle-login-copy">
              <h1>{LOCALIZATION.LOGIN_PAGE_TAGLINE}</h1>
              <a
                href={VYTELLE_MARKETING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="vytelle-login-cta"
              >
                {LOCALIZATION.START_NOW}
              </a>
            </div>

            <div className="vytelle-login-panel">
              <div className="shadow-card">
                <LoginForm
                  showSignUp={false}
                  identifierType="email"
                  identifierLabel={LOCALIZATION.USERNAME}
                  identifierPlaceholder={LOCALIZATION.USERNAME}
                  showTitle={false}
                  showFieldLabels={true}
                />
                <div className="footer-links login-footer-links">
                  <span>{LOCALIZATION.NEED_HELP}?</span>
                  <a href="mailto:info@vytelle.com">
                    {LOCALIZATION.CONTACT_CUSTOMER_SUPPORT}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default VytelleLogin;
